import firebase from 'firebase';
import 'firebase/firestore';

const config = {
  apiKey: "AIzaSyCU38k7WzilKkd23uXvVDnKgs5ChqNO9sE",
  authDomain: "just-thank-you.firebaseapp.com",
  databaseURL: "https://just-thank-you.firebaseio.com",
  projectId: "just-thank-you",
  storageBucket: "just-thank-you.appspot.com",
  messagingSenderId: "156548045934"
};

firebase.initializeApp(config);
firebase.firestore().settings({timestampsInSnapshots: true})

export default firebase;

// export const database = firebase.database();
export const auth = firebase.auth();
export const storage = firebase.storage();
export const emailAuthProvider = new firebase.auth.EmailAuthProvider()
export const phoneAuthProvider = new firebase.auth.PhoneAuthProvider()
export const messaging = firebase.messaging()
export const db = firebase.firestore()



// WEBPACK FOOTER //
// ./src/helpers/firebase.js